// extracted by mini-css-extract-plugin
export var container = "_do-0";
export var icon = "_do-1";
export var text = "_do-2";